import { render } from "./FotosChamado.vue?vue&type=template&id=103cb85e&scoped=true"
import script from "./FotosChamado.vue?vue&type=script&lang=js"
export * from "./FotosChamado.vue?vue&type=script&lang=js"

import "./FotosChamado.vue?vue&type=style&index=0&id=103cb85e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-103cb85e"]])

export default __exports__